import React from "react";
import modalStyles from "@/styles/Modal.module.scss";
import { Button } from "../Buttons";
import { useCallback, useEffect, useState, useRef, forwardRef } from "react";
import routes from "@/lib/routes";
import ChatMessageReportStepInit from "./ChatMessageReportStepInit";
import ChatMessageReportStepMute from "./ChatMessageReportStepMute";
import ChatMessageReportStepReport from "./ChatMessageReportStepReport";
import { useChatReportMessageMutation } from "@/hooks";

const ChatMessageReportModal = (props) => {
  const [mode, setMode] = useState("init");
  const reportCompleteHandle = useCallback(
    (id) => {
      props.handleReportComplete(id);
      props.reportComplete();
    },
    [props]
  );
  const [reportChatMessageMutation] = useChatReportMessageMutation({
    onCompleted: ({ chatReportMessage }) => {
      console.log(chatReportMessage?.result);
      // 必要あれば通報したメッセージを消去する処理を追加
      reportCompleteHandle(props.id);
    },
    onError: (e) => {
      console.log("error on reportMessage:", e);
    },
  });

  const setStepInit = useCallback(() => {
    setMode("init");
  }, []);

  const setStepMute = useCallback(() => {
    setMode("mute");
  }, []);

  const setStepReport = useCallback(() => {
    setMode("report");
  }, []);

  const childProps = {
    ...props,
    setStepInit: setStepInit,
    setStepMute: setStepMute,
    setStepReport: setStepReport,
  };

  const reportSend = (id, reason) => {
    if (!reason) return;
    reportChatMessageMutation({
      variables: {
        roomId: props.roomId,
        messageId: id,
        reason: reason,
      },
    });
  };

  return (
    <>
      <div className={modalStyles.container}>
        {mode === "init" && (
          <ChatMessageReportStepInit
            {...childProps}
            reportedMessageIds={props.reportedMessageIds}
          />
        )}
        {mode == "mute" && <ChatMessageReportStepMute {...childProps} />}
        {mode == "report" && (
          <ChatMessageReportStepReport
            {...childProps}
            handleReportSend={reportSend}
          />
        )}
      </div>
    </>
  );
};

export default ChatMessageReportModal;
